import { useRecoilState } from 'recoil';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import useBranches from '@ubeya/shared/hooks/account/useBranches';
import * as sharedAtoms from '@ubeya/shared/atoms/shared';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { getSelectedBranchKeyByAccountId } from '@ubeya/shared/constants';

const useInitialState = () => {
  const { accountId } = useAccount();
  const { isLoading, branchesOptions } = useBranches();
  const [selectedBranches, setSelectedBranches] = useRecoilState(sharedAtoms.selectedBranches);
  const [selectedBranch, setSelectedBranch] = useRecoilState(sharedAtoms.selectedBranch);

  // INITIAL STATE
  useEffect(() => {
    if (isEmpty(selectedBranches) && branchesOptions.length > 0) {
      setSelectedBranches(branchesOptions.map(({ value }) => value));

      const SELECTED_BRANCH_LOCAL_STORAGE = getSelectedBranchKeyByAccountId(accountId);
      const savedBranchId = localStorage.getItem(SELECTED_BRANCH_LOCAL_STORAGE);
      const selected = branchesOptions.find(({ value }) => value === parseInt(savedBranchId, 10))?.value;
      setSelectedBranch(selected ?? branchesOptions[0]?.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchesOptions]);

  // if changing selectedBranches to 'ALL' → not changing selectedBranch
  // if changing selectedBranches to 1 → changing selectedBranch to 1
  useEffect(() => {
    if (selectedBranches?.length === 1) {
      setSelectedBranch(selectedBranches[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBranches]);

  // when changing selectedBranch → if selectedBranches is ALL - not changing selectedBranches
  // when changing selectedBranch → if selectedBranches is 1 → changing selectedBranches to new branch
  useEffect(() => {
    if (selectedBranches?.length === 1) {
      setSelectedBranches([selectedBranch]);
    }

    const SELECTED_BRANCH_LOCAL_STORAGE = getSelectedBranchKeyByAccountId(accountId);
    selectedBranch && localStorage.setItem(SELECTED_BRANCH_LOCAL_STORAGE, selectedBranch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBranch]);

  return { isLoading };
};

export default useInitialState;
